import { Button, Dialog, FieldLabel } from '@myosh/odin-components';
import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PROMPT_CHARACTER_LIMIT = 2000;

export interface AnalyzeRecordsModalResult {
  action: 'analyze' | 'dismiss';
  data?: string;
}

interface AnalyzeRecordsModalProps {
  visible: boolean;
  analyzeRecord: (data: string) => void;
  onClose: () => void;
}

const AnalyzeRecordsModal = ({ visible, onClose, analyzeRecord }: AnalyzeRecordsModalProps) => {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleAnalyze = useCallback(() => {
    const inputValue = inputRef.current?.value || '';
    const cappedValue =
      inputValue.length > PROMPT_CHARACTER_LIMIT ? inputValue.substring(0, PROMPT_CHARACTER_LIMIT) : inputValue;
    analyzeRecord(cappedValue);

    onClose();
  }, [analyzeRecord, onClose]);

  return (
    <>
      {visible && (
        <Dialog header={t('ai-analyse-records')} onClose={onClose} visible={visible}>
          <div className="flex flex-col gap-3">
            <FieldLabel label={t('custom-instructions')} />
            <textarea
              ref={inputRef}
              name="custom-instructions"
              placeholder={t('custom-instructions-placeholder')}
              rows={8}
              maxLength={PROMPT_CHARACTER_LIMIT}
              className="custom-scroll bg-mono-1 px-2 leading-4 border border-gray-2 relative block w-full py-1 placeholder-gray-3 text-sm focus:outline-none"
            />

            <div className="flex justify-center">
              <Button type="primary" variant="alternative" onClick={handleAnalyze}>
                {t('analyse-records')}
              </Button>
            </div>

            <p className="self-start text-xs text-warning">{t('ai-data-warning')}</p>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default AnalyzeRecordsModal;
